import ApiClient from '../../services/apiClient';
import { useQuery } from 'react-query';
import { LookupDataEnums } from '../../utilities/Constants';

const _apiClient = new ApiClient();

export const useGetDepositionCategories = () => {
    return useQuery({
        queryKey: ['get-deposition-categories'],
        queryFn: async () => {
            const response = await _apiClient.getLookupData(LookupDataEnums.DepositionCategories);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve deposition categories.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
    });
};
